import { schema as schemas } from 'normalizr'
import { CallApi } from '@signavio/kraken'

import { ADMIN_API_BASE } from '../../callApi'

export const collection = 'adminUserEmailAddress'

export const schema = new schemas.Entity(collection)

export const update =
  (callApi: CallApi) => (query: { userId: string }, emailAddress: string) => {
    return callApi(
      `${ADMIN_API_BASE}/users/${query.userId}/email-address`,
      schema,
      {
        method: 'PUT',
        body: {
          emailAddress,
        },
      }
    )
  }
